import React from 'react';
import {
    SkeletonContainer,
    SkeletonLine,
    RowLinesSkeletonList,
} from '../styled';
import { SkeletonAnimation } from '../skeletonAnimation';
import { detectMobile } from '../../../utils/UiHelper';

const AndetPageSkeleton = ({ margin }) => {
    const isMobile = detectMobile();
    const itemCount = isMobile ? 12 : 24;

    const renderSkeletonLines = () =>
        Array.from({ length: itemCount }, (_, index) => (
            <SkeletonLine
                height={'40px'}
                margin={'0'}
                radius={'4px'}
                bC={'#ffffff'}
                borderColor={'#E4E9EF'}
                key={`andet_item_${index}`}
            />
        ));

    return (
        <SkeletonContainer
            isMobile={isMobile}
            padding={'0'}
            margin={margin || '0'}
        >
            <RowLinesSkeletonList gap={'4px'}>
                {renderSkeletonLines()}
            </RowLinesSkeletonList>
            <SkeletonAnimation />
        </SkeletonContainer>
    );
};

export default AndetPageSkeleton;
